function ForgotPasswordPage() {
  return null;
}

ForgotPasswordPage.page_type = "forgot_password";
ForgotPasswordPage.pageComponentPlacementIndex = 1;

export default ForgotPasswordPage;
